// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"9b5a623c","732":"3541d1df","909":"7e5a0dcf"}[chunkId] + ".chunk.css";
};